/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["envato-purchases-panel{display:block}envato-purchases-panel .purchase{display:flex;margin-bottom:15px;padding-bottom:15px;border-bottom:1px solid #eff1f2}envato-purchases-panel .purchase>.image{width:60px;height:60px;margin-right:10px}envato-purchases-panel .purchase>.image>img{width:inherit;height:inherit}envato-purchases-panel .purchase .item-name{color:inherit;font-weight:500;font-size:1.5rem}envato-purchases-panel .purchase .item-name:hover{text-decoration:underline}"];
export { styles as styles };
